// extracted by mini-css-extract-plugin
export default {"content":"style_content__di8t9","itemName":"style_itemName__cUbA5"};